
webpack.register(
    'modules/live-video-pop-out/live-alert/live-alert',
    function() {
        return import('modules/live-video-pop-out/live-alert/live-alert');
    },
    true
);